var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCsuLarge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63 58",
    style: {
      enableBackground: "new 0 0 63 58"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#982B56;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63,0v58H0V0H63z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.4,55.8c1.1,0,2-0.9,2-2V36.6l4.6,4.6c0.7,0.8,2,0.9,2.8,0.1c0.8-0.7,0.9-2,0.1-2.8l-0.1-0.1l-8-8 c-0.8-0.8-2-0.8-2.8,0l-8,8c-0.7,0.8-0.7,2.1,0.1,2.8s1.9,0.7,2.7,0l4.6-4.6v17.2C15.4,54.9,16.3,55.8,17.4,55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.8,30.3c-0.8-0.8-2-0.8-2.8,0l-8,8c-0.7,0.8-0.7,2.1,0.1,2.8s1.9,0.7,2.7,0l4.6-4.6v17.2c0,1.1,0.9,2,2,2 s2-0.9,2-2V36.6l4.6,4.6c0.7,0.8,2,0.9,2.8,0.1c0.8-0.7,0.9-2,0.1-2.8l-0.1-0.1L46.8,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.9,24.6L33.6,3.3c-0.6-1-1.9-1.4-2.9-0.8c-0.3,0.2-0.6,0.5-0.8,0.8L17.6,24.6c-0.4,0.7-0.2,1.6,0.5,2 c0.2,0.1,0.5,0.2,0.7,0.2h25.8c0.8,0,1.4-0.6,1.4-1.4C46.1,25.1,46,24.8,45.9,24.6z M31.7,22.6c-0.7,0-1.2-0.5-1.2-1.2 s0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2l0,0C32.9,22,32.4,22.6,31.7,22.6L31.7,22.6z M32.9,17.2c0.1,0.7-0.4,1.2-1.1,1.3 c-0.7,0.1-1.2-0.4-1.3-1.1c0-0.1,0-0.1,0-0.2v-6.6c-0.1-0.7,0.4-1.2,1.1-1.3c0.7-0.1,1.2,0.4,1.3,1.1c0,0.1,0,0.1,0,0.2V17.2z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCsuLarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CSU-large.181449dded7d61b9c5da436d01265bd3.svg";